module.exports = __webpack_public_path__ + "static/media/amazon(icon).966367a9.svg";